<template>
<div>
	<div class="table-footer main_footer_wrap">
			<div class="row">
				<div class="col-md-4">
					<span>Show </span>
					<select
						style="min-width: fit-content;"
						class="form-control"
						id="resultsPerPage"
						v-model="showPerPage"
						@change="showPerPageChanged()"
					>
						<option>10</option>
						<option>25</option>
						<option>50</option>
						<option>100</option>
						<option>500</option>
						<option>1000</option>
					</select>
					<span>Entries</span>
				</div>
				<!-- <div class="col-md-6 text-center" v-if ="isShowButton>0">
					<div v-show="isShowAddToCampaigngroup">
						<span>Selected Ones</span>
						<button class="btn btn-danger" @click="dissociateCampaignGroup()">
							<svg viewBox="0 0 8 8" class="icon fill-white">
								<use xlink:href="images/open-iconic.svg#trash"></use>
							</svg>
							Remove From Campaign Group(s)
						</button>
						<button class="btn btn-primary go-popover" @click="openAddToGroupModal">Add to Campaign Group</button>
					</div>
				</div> -->
				<div class="col-md-4 text-center"></div>
				<div class="col-md-4 text-right">
					<a
						href="javascript:void(0)"
						v-if="currentPageNumber != 1"
						@click="getPreviousPageList()"
					>Previous </a>
						<select
							class="form-control selectpicker"
							style = 'max-width:80px;'
							id="brandFilter"
							v-model="currentPageNumber"
							@change="getNewPageList()"
						>
							<option
								v-for="index in totalNoOfPages"
								:key="index"
								:value="index"
							>{{index}}</option>
						</select>
					<a
						href="javascript:void(0)"
						v-if="(showPerPage == campaignList.length && (currentPageNumber!=totalNoOfPages))"
						@click="getNextPageList()"
					> Next</a>
					<div style = "padding-right:0px;padding-top:5px">{{getCount()}}</div>
				</div>
			</div>
		</div>
		<AddToCampaignGroupModal
			@editCampaignGroup="editCampaignGroup"
			@hideAddToCampaignGroupModal="hideAddToCampaignGroupModal"
			@bulkCampaignGroupAssociation="bulkCampaignGroupAssociation"
		></AddToCampaignGroupModal>
	</div>
</template>

<script>
	import DeletePopUp from "../delete/DeletePopUp.vue";
	import AddToCampaignGroupModal from "@/components/campaign/AddToCampaignGroupModal.vue";
	export default {
		name: "CampaignListGridFooter",
		components: {
			DeletePopUp,
			AddToCampaignGroupModal
		},
		data() {
			return {
				isGroupId: false,
				showNewCampignGroup: false,
				isOpenDeleteModal: false,
				showPopover: false,
				totalNoOfPages:1,
				dropSize:1
			};
		},
		props: {
			campaignToAddToGroup: Array,
			modalShow: Boolean,
			getFilteredResult:Boolean
		},
		mounted() {
			this.calculateIndexPerPage()
		},
		beforeMount() {
			if (this.$route.params && this.$route.params.groupId) {
				this.isGroupId = false;
			} else {
				this.isGroupId = true;
			}
		},
		watch:{
			totalCampaignAndProductCount(){

				this.calculateIndexPerPage()
				//return this.$store.state.totalCampaignAndProductCount
			}
		},
		computed: {
			totalCampaignAndProductCount:{
				get(){

					return this.$store.state.totalCampaignAndProductCount
				},
				set(val){

					return this.$store.state.totalCampaignAndProductCount = val;


				}
			},
			isShowButton() {
				return this.$store.state.campaign.campaignToAddToGroupList.length;
			},

			selectedCampaignGroup: {
				get() {
					return this.$store.state.latestCampaignGroup;
				},
				set(val) {
					this.$store.state.latestCampaignGroup = val;
				}
			},
			isShowAddToCampaigngroup() {
				return this.$store.state.selectedVendorFilter ? true : false;
			},
			showPerPage: {
				set(val) {
					sessionStorage.setItem("campaign:showPerPage", val);
				},
				get() {
					if (sessionStorage.getItem("campaign:showPerPage")) {
						return sessionStorage.getItem("campaign:showPerPage");
					}
					return this.$store.state.showPerPage;
				}
			},
			currentPageNumber: {
				set(val) {
					this.resetCampAction()
					this.$store.state.currentPageNumber = val;
				},
				get() {
					return this.$store.state.currentPageNumber;
				}
			},
			campaignGroupFilterList() {
				return this.$store.state.campaign.campaignGroupFilterList;
			},
			campaignList: {
				get() {
					return this.$store.state.campaign.campaignList;
				}
			}
		},

		methods: {
			resetCampAction(){
				this.$store.state.campaign.actionSelectionControl = false
				this.$store.state.campaign.campaignSelectedList = []
				this.$store.state.campaign.campaignToAddToGroupList = []
			},
			calculateIndexPerPage(){

               this.totalNoOfPages=Math.ceil(this.totalCampaignAndProductCount/this.showPerPage) ? Math.ceil(this.totalCampaignAndProductCount/this.showPerPage) : this.totalNoOfPages
			},
			hideAddToCampaignGroupModal(data) {
				$("#addToCampaignGroup").modal("hide");
			},
			editCampaignGroup() {
				this.$emit("openCampaignModal");
			},
			getPreviousPageList() {
				if (this.currentPageNumber <= 1) {
					return;
				} else {
					
					this.currentPageNumber -= 1;
					if(this.getFilteredResult){
						this.$emit("getList")
					}
					else{
						this.$store.dispatch("campaign/getCampaignList");
					}
				}
			},
			setSize(size){
				this.dropSize = size
			},
			getNextPageList() {
				
				this.currentPageNumber += 1;
				if(this.getFilteredResult){
					this.$emit("getList")
				}
				else{
					this.$store.dispatch("campaign/getCampaignList");
				}
			},
			getNewPageList(){
				
				if(this.getFilteredResult){
					this.$emit("getList")
				}
				else{
					this.$store.dispatch("campaign/getCampaignList");
				}
			},
			showPerPageChanged() {
				
				this.currentPageNumber = 1
				if(this.getFilteredResult){
					this.$emit("getList")
				}
				else{
					this.$store.dispatch("campaign/getCampaignList");
				}
			},
			openAddToGroupModal() {
				$("#addToCampaignGroup").modal("show");
			},
			getCount(){
				let pageCount = (this.showPerPage * (this.currentPageNumber - 1));
				let extendedcount = parseInt(pageCount)+ parseInt(this.campaignList.length);
				return	'Showing ' + (pageCount+1) + ' to ' + extendedcount + ' results of ' + this.totalCampaignAndProductCount;
			},
			bulkCampaignGroupAssociation() {
				let vm = this;
				console.log(this.selectedCampaignGroup);
				console.log(this.$store.state.campaign.campaignToAddToGroupList);
				let arr = this.$store.state.campaign.campaignToAddToGroupList;
				var id = this.selectedCampaignGroup;
				this.selectedCampaignGroup = "";
				let payload = {
					campaign_group_id: id,
					campaign_id: arr,
					requestType: "add",
					vendor_id: this.$store.state.selectedVendorFilter
				};
				if (arr.length) {
					this.$store.commit('showLoadingSpinner', null, {
					root: true
				})
					this.$store
						.dispatch("campaign/addCampaignToCampaignGroups", payload)
						.then(res => {
							vm.$store.state.campaign.campaignToAddToGroupList = [];
							vm.$store
								.dispatch("campaign/getCampaignList", {})
								.then(res => {
									console.log(res);
								});
						});
				}
				$("#addToCampaignGroup").modal("hide");
			},
			dissociateCampaignGroup() {
				this.isOpenDeleteModal = true;
			},
			deleteData() {
				this.hideDeleteModal();
				let vm = this;
				let arr = this.$store.state.campaign.campaignToAddToGroupList;
				let payload = {
					campaign_group_id: "",
					campaign_id: arr,
					requestType: "del",
					vendor_id: this.$store.state.selectedVendorFilter
				};
				if (arr.length) {
					this.$store
						.dispatch("campaign/addCampaignToCampaignGroups", payload)
						.then(res => {
							// javascript:$('.go-popover').popover('hide');

							console.log(res);
							vm.$store
								.dispatch("campaign/getCampaignList", {})
								.then(res => {
									console.log(res);
								});
						});
				}
			},
			hideDeleteModal() {
				this.isOpenDeleteModal = false;
			}
		}
	};
</script>

<style lang="scss">

</style>
